export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/cK5KfZGB3WP4HZpxc5pUH6/MOCKUP_HEIR.png'

export const MOCKUP_ALT =
  'Hair Extension Instructor Ready™ — six pastel volumes with interior pages shown on a tablet, laptop and phone'
